import Cookies from 'js-cookie';

const TR_SM_COOKIE = 'tr_sm';

export function getTrSm(): string | undefined {
  return Cookies.get(TR_SM_COOKIE) || undefined;
}
